<template>
  <div class="address-window-component">
    <v-loader v-if="isLoading" absolute />
    <s-tabs>
      <s-tab name="Доставка" :selected="currentTab === 'delivery'">
        <template v-if="!showNewAddressSection">
          <h1 class="step-title font-weight-regular">
            Адреса клиента:
          </h1>
          <div class="button-group d-flex justify-between">
            <v-row dense class="justify-space-between">
              <v-col sm="5">
                <v-btn
                  class="button button-back"
                  width="100%"
                  color="#F1F3F6"
                  @click="stepBack"
                >
                  <font-awesome-icon icon="chevron-left" />
                  Вернуться назад
                </v-btn>
              </v-col>
              <v-col sm="5">
                <v-btn
                  class="button button-apply"
                  width="100%"
                  color="#F1F3F6"
                  :disabled="!currentAddressId && !isYandexDelivery && !isDeliveryClub"
                  @click="updateAddress"
                >
                  <font-awesome-icon icon="check" />
                  Подтвердить адрес
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-checkbox
            v-show="isSourceYandex || isYandexDelivery"
            v-model="isYandexDelivery"
            label="Доставляет Яндекс курьер"
            hide-details="auto"
            class="crm-checkbox mb-10"
            @change="isDeliveryClub = false"
          />

          <v-checkbox
            v-show="isSourceDeliveryClub || isDeliveryClub"
            v-model="isDeliveryClub"
            label="Доставляет Delivery Club курьер"
            hide-details="auto"
            class="crm-checkbox mb-10"
            @change="isYandexDelivery = false"
          />

          <div v-if="!isYandexDelivery && !isDeliveryClub" class="address-section">
            <template v-if="addressItems.length">
              <v-address
                v-for="(item, i) in addressItems"
                :key="`address-${item.id}`"
                v-model="currentAddressId"
                :item="item"
                :checked="item.id === currentAddressId"
                @onEdit="openEditWindow"
              />
            </template>
            <template v-if="!addressItems.length && !isLoading">
              <span class="d-block display-3 text-center">Нет адресов</span>
            </template>
          </div>

          <div v-if="!isYandexDelivery && !isDeliveryClub" class="new-address-section">
            <span class="label">Новый адрес:</span>
            <v-btn
              class="button-add"
              width="100%"
              dark
              depressed
              @click="openNewAddressWindow"
            >
              <span class="d-flex flex-column align-center font-weight-medium">
                <font-awesome-icon icon="plus" />
                Новый адрес
              </span>
            </v-btn>
          </div>
        </template>

        <template v-if="showNewAddressSection">
          <h1 class="step-title font-weight-regular">
            Новый адрес:
          </h1>
          <div class="button-group d-flex justify-between">
            <v-row dense class="justify-space-between">
              <v-col sm="5">
                <v-btn
                  :disabled="isLoading"
                  class="button button-back"
                  width="100%"
                  color="#F1F3F6"
                  @click="showNewAddressSection = false"
                >
                  <font-awesome-icon icon="chevron-left" />
                  Вернуться назад
                </v-btn>
              </v-col>
              <v-col sm="5">
                <v-btn
                  :loading="isLoading"
                  class="button button-apply"
                  width="100%"
                  color="#F1F3F6"
                  @click="addNewAddress"
                >
                  <font-awesome-icon icon="check" />
                  Сохранить адрес
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div class="street-section">
            <v-row>
              <v-col sm="3">
                <div class="street-field">
                  <span class="label">Город:</span>
                  <v-text-field
                    v-model="city"
                    hide-details="auto"
                    class="text-field"
                    flat
                    solo
                    readonly
                    disabled
                  />
                </div>
              </v-col>
              <v-col sm="6">
                <div class="street-field">
                  <span class="label">Улица:</span>
                  <street-input
                    v-model="street"
                    :init-val="street"
                    @selected="onSelectStreet"
                    @clear-obj="clearHouse"
                  />
                </div>
              </v-col>
              <v-col sm="3">
                <span class="label">Дом, корпус:</span>
                <house-input
                  v-model="house"
                  :disabled="isHouseInputDisabled"
                  :street-id="streetId"
                  :init-val="house"
                  @selected="onSelectHouse"
                />
              </v-col>
            </v-row>

            <v-row class="address-inputs">
              <v-col sm="4">
                <span class="label">Кв/офис:</span>
                <v-text-field
                  v-model="apartmentNumber"
                  hide-details="auto"
                  class="text-field"
                  flat
                  solo
                  @focus="currentKeyboard = 'apartment'"
                />
              </v-col>
              <v-col sm="4">
                <span class="label">Этаж:</span>
                <v-text-field
                  v-model="floor"
                  hide-details="auto"
                  class="text-field"
                  flat
                  solo
                  @focus="currentKeyboard = 'floor'"
                />
              </v-col>
              <v-col sm="4">
                <span class="label">Подъезд:</span>
                <v-text-field
                  v-model="entry"
                  hide-details="auto"
                  class="text-field"
                  flat
                  solo
                  @focus="currentKeyboard = 'entry'"
                />
              </v-col>
            </v-row>
            <v-row class="streets flex-wrap">
              <v-col v-for="(suggest, i) in suggests.slice(0, 4)" :key="i" sm="3">
                <v-btn
                  v-if="suggest.street"
                  class="button text-normalize"
                  width="100%"
                  depressed
                  @click="setAddressData(suggest)"
                >
                  {{ suggest.street }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>
      </s-tab>

      <s-tab name="Самовывоз" :selected="currentTab === 'pickup'">
        <h1 class="step-title font-weight-regular">
          Самовывоз:
        </h1>

        <div class="button-group d-flex justify-between">
          <v-row dense class="justify-space-between">
            <v-col sm="5">
              <v-btn
                class="button button-back"
                width="100%"
                color="#F1F3F6"
                @click="stepBack"
              >
                <font-awesome-icon icon="chevron-left" />
                Вернуться назад
              </v-btn>
            </v-col>
            <v-col sm="5">
              <v-btn
                class="button button-apply"
                width="100%"
                color="#F1F3F6"
                :disabled="!pickupPoint"
                @click="setPickupPoint"
              >
                <font-awesome-icon icon="check" />
                Сохранить пункт самовывоза
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <div class="addresses-section">
          <span class="label">Выберите пункт самовывоза:</span>
          <template v-if="filials.length">
            <v-row>
              <v-col v-for="(item, i) in filials" :key="`pickup-point-${item.id}`" sm="4">
                <pickup-point
                  v-model="pickupPoint"
                  name="point"
                  :value="item.id"
                  :item="item"
                  :checked="item.id === pickupPoint"
                  @change="currentAddressId = null"
                />
              </v-col>
            </v-row>
          </template>
          <template v-if="!filials.length">
            <span class="d-block display-3 text-center">Нет пунктов самовывоза</span>
          </template>
        </div>
      </s-tab>
    </s-tabs>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import VAddress from '@/components/order-processing/order-components/second-step/Address'
  import PickupPoint from '@/components/order-processing/order-components/second-step/PickupPoint'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import StreetInput from '@/components/ui/address/StreetInput'
  import HouseInput from '@/components/ui/address/HouseInput'
  import _ from 'lodash'
  import STabs from '@/components/ui/tabs/STabs.vue'
  import STab from '@/components/ui/tabs/STab.vue'

  export default {
    name: 'AddressWindow',
    components: {
      STab,
      STabs,
      VLoader,
      VAddress,
      PickupPoint,
      StreetInput,
      HouseInput,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        isLoading: false,
        isYandexDelivery: false,
        isDeliveryClub: false,
        addressItems: [],
        showAddressForm: false,
        currentTab: 'delivery',
        pickupPoint: '',
        currentKeyboard: 'street',
        city: '',
        street: '',
        house: '',
        apartment: '',
        apartmentNumber: '',
        floor: '',
        entry: '',
        timeout: null,
        suggests: [],
        currentAddressId: '',
        currentEditItemId: null,
        streetObj: {},
        houseObj: {},
      }
    },
    watch: {
      basket () {
        this.setDeliveryTab()
      },
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
        order: (state) => state.orders.currentEditOrder,
        filials: state => state.branches.branches,
      }),
      isSourceYandex () {
        return this.basket.basketSource === 'yandex'
      },
      isSourceDeliveryClub () {
        return this.basket.basketSource === 'deliveryСlub'
      },
      isHouseInputDisabled () {
        return _.isEmpty(this.streetObj)
      },
      streetId () {
        return this.streetObj ? this.streetObj.id : null
      },
      hasGeoData () {
        return this.houseObj ? this.houseObj.hasGeo : false
      },
      fullHouseAddress () {
        return [this.city, this.street, this.house].join(', ')
      },
      getLatitude () {
        return this.hasGeoData ? this.houseObj.latitude : null
      },
      getLongitude () {
        return this.hasGeoData ? this.houseObj.longitude : null
      },
    },
    mounted () {
      if (this.basket.clientAddress && this.basket.clientAddress.id) {
        this.currentAddressId = this.basket.clientAddress.id
      }
      if (this.basket.filialId) {
        this.selectedFilial = this.basket.filialId
      }
      if (this.basket.deliveryType === 'yandex') {
        this.isYandexDelivery = true
      }
      if (this.basket.deliveryType === 'deliveryClub') {
        this.isDeliveryClub = true
      }
      this.getAddresses()
      this.getFilials()

      this.setDeliveryTab()
    },
    methods: {
      onSelectHouse (obj) {
        console.log({ selectHouse: obj })
        this.houseObj = obj || {}
      },
      clearHouse () {
        this.house = null
      },
      onSelectStreet (obj) {
        console.log({ selectStreet: obj })
        this.streetObj = obj
        this.city = obj ? obj.city : ''
      },
      saveBasketSource (source) {
        this.basket.basketSource = source
        const data = {
          basketSource: source,
        }
        const id = this.basket.id
        this.$store
          .dispatch('baskets/updateBasket', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      setCityFromSearch () {
        if (this.suggests.length === 1) {
          this.city = this.suggests[0].city
        }
      },
      setAddressData (suggest) {
        this.city = suggest.city
        this.street = suggest.street
      },
      openNewAddressWindow () {
        this.city = ''
        this.street = ''
        this.house = ''
        this.apartment = ''
        this.apartmentNumber = ''
        this.entry = ''
        this.floor = ''
        this.showNewAddressSection = true
        this.currentEditItemId = null
      },
      openEditWindow (item) {
        this.currentEditItemId = item.id
        this.city = item.city || ''
        this.street = item.street || ''
        this.house = item.house || ''
        this.apartment = item.apartment || ''
        this.apartmentNumber = item.apartmentNumber || ''
        this.entry = item.entry || ''
        this.floor = item.floor || ''
        this.showNewAddressSection = true
      },
      addNewAddress () {
        this.isLoading = true
        const data = {
          city: this.city,
          street: this.street,
          house: this.house,
          apartmentNumber: this.apartmentNumber,
          entry: this.entry,
          floor: this.floor,
          houseFullAddress: this.fullHouseAddress,
          latGeo: this.getLatitude,
          letGeo: this.getLongitude,
        }
        if (this.currentEditItemId === null) {
          const id = this.order.client.id
          this.$store
            .dispatch('clients/addAddressClients', { data, id })
            .then((res) => {
              if (res.status === 200) {
                this.showSuccessMessage('Адрес создан')
                this.getAddresses()
                this.closeNewAddressSection()
              } else {
                this.showErrorMessage(res.response.data.message)
              }
              this.isLoading = false
            })
        } else {
          const id = this.currentEditItemId
          this.$store
            .dispatch('clients/editAddressClients', { data, id })
            .then((res) => {
              if (res.status === 200) {
                this.showSuccessMessage('Адрес обновлен')
                this.getAddresses()
                this.closeNewAddressSection()
              } else {
                this.showErrorMessage(res.response.data.message)
              }
              this.isLoading = false
            })
        }
      },
      setPickupPoint () {
        this.isLoading = true
        const id = this.basket.id
        console.log(this.pickupPoint)
        const data = {
          filialId: this.pickupPoint,
        }
        this.$store
          .dispatch('baskets/changeDeliveryToPickup', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.showSuccessMessage('Точка самовывоза установлена')
              this.$store.commit('newOrder/setSecondStepWindow', 'payment')
              this.$store
                .dispatch('baskets/fetchSingleBasket', this.basket.id)
                .then((res) => {
                  if (res.status !== 200) {
                    this.showErrorMessage(res.response.data.message)
                  }
                })
            } else {
              this.showErrorMessage(res.response.data.message)
            }
            this.isLoading = false
          })
      },
      updateAddress () {
        this.isLoading = true
        const id = this.basket.id
        if (this.isYandexDelivery) {
          this.$store.dispatch('baskets/changeOnYandexDelivery', id)
            .then(res => {
              if (res.status === 200) {
                this.$store.commit('newOrder/setSecondStepWindow', 'payment')
                this.$store
                  .dispatch('baskets/fetchSingleBasket', this.basket.id)
                  .then((res) => {
                    if (res.status !== 200) {
                      this.showErrorMessage(res.response.data.message)
                    }
                  })
              } else {
                this.showErrorMessage(res.response.data.message)
              }
            }).finally(() => {
              this.isLoading = false
            })
        } else if (this.isDeliveryClub) {
          this.$store.dispatch('baskets/changeOnDeliveryClub', id)
            .then(res => {
              if (res.status === 200) {
                this.$store.commit('newOrder/setSecondStepWindow', 'payment')
                this.$store
                  .dispatch('baskets/fetchSingleBasket', this.basket.id)
                  .then((res) => {
                    if (res.status !== 200) {
                      this.showErrorMessage(res.response.data.message)
                    }
                  })
              } else {
                this.showErrorMessage(res.response.data.message)
              }
            }).finally(() => {
              this.isLoading = false
            })
        } else {
          const data = {
            clientAddressId: this.currentAddressId,
          }
          this.$store
            .dispatch('baskets/updateBasketAddress', { data, id })
            .then((res) => {
              if (res.status === 200) {
                this.showSuccessMessage('Адрес обновлен')
                this.$store.commit('newOrder/setSecondStepWindow', 'payment')
                this.$store
                  .dispatch('baskets/fetchSingleBasket', this.basket.id)
                  .then((res) => {
                    if (res.status !== 200) {
                      this.showErrorMessage(res.response.data.message)
                    }
                  })
              } else {
                this.showErrorMessage(res.response.data.message)
              }
              this.isLoading = false
            })
        }
      },
      closeNewAddressSection () {
        this.showNewAddressSection = false
        this.currentEditItemId = null
      },
      stepBack () {
        this.$store.commit('fastOrder/setStep', 1)
      },
      setTab (tab) {
        this.currentTab = tab
      },
      getAddresses () {
        const payload = {
          clientId: this.order.client.id,
          limit: 100000,
        }
        this.isLoading = true
        this.$store
          .dispatch('clients/fetchClientsAddressList', payload)
          .then((res) => {
            this.isLoading = false
            if (res.status === 200) {
              this.addressItems = res.data.items
              if (this.addressItems.length) {
                this.addressItems.sort((a, b) => {
                  if (a.id < b.id) {
                    return 1
                  }
                  if (a.id > b.id) {
                    return -1
                  }
                  return 0
                })
              }
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      getFilials () {
        this.$store
          .dispatch('branches/fetchBranches', {
            limit: 100000,
            offset: 0,
            page: 1,
          })
      },
      setDeliveryTab () {
        if (this.basket.deliveryType === 'self') {
          this.currentTab = 'pickup'
          this.pickupPoint = this.basket.filialId
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.address-window-component {

  background-color: #fafafa;

  font-size: 12px;

  .media-xl({
    font-size: 14px;
    padding-top: 30px;
  });

  .filials-section {
    margin-bottom: 24px;

    .label {
      font-size: 24px;
      display: block;
    }
  }

  .tabs {
    margin-bottom: 33px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      flex: 1;
      outline: none;
      font-size: 24px;
      line-height: 21px;
      border-radius: 14px 14px 0 0;
      height: 57px;

      &.active {
        background-color: #191919;
        font-weight: 900;
        color: @color-primary;
      }
    }
  }

  .step-title {
    font-size: 2.42em;
    line-height: 1;
    margin-bottom: 0.97em;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      border-radius: 10px;

      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-apply {
      background-color: @color-success !important;
      color: #ffffff;
      border-radius: 10px;

      &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        box-shadow: none !important;

        svg {
          .fill-svg(#00000042);
        }
      }

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .address-section {
    margin-bottom: 22px;
  }

  .new-address-section {
    .label {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 25px;
    }

    .button-add {
      background-color: @color-primary !important;
      height: 6.7em;

      svg {
        width: 20px;
        height: 20px;
        margin-bottom: 12px;
      }
    }
  }

  .addresses-section {
    .label {
      display: block;
      font-size: 20px;
      line-height: 21px;
      margin-bottom: 31px;
    }
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .street-section {
    .streets {
      min-height: 104px;
    }

    .street-field {
      margin-bottom: 23px;
    }

    .label {
      display: block;
      margin-bottom: 14px;
      font-size: 20px;
      line-height: 21px;
    }

    .button {
      min-height: 80px;
      font-size: 24px;
      line-height: 18px;
      white-space: initial !important;
      background-color: @color-secondary !important;

      ::v-deep {
        .v-btn__content {
          display: block;
          word-break: break-all;
          width: 100%;
        }
      }
    }
  }
}
</style>
